/** Live updates from the server (stock, counters, catalogue) over WebSocket. */
import { useEffect, useRef } from 'react';

import { TOKEN_KEY, wsUrl } from '../services/api';

export interface LiveEvent { id: number; kind: string; payload: any; at: string }

export function useLiveEvents(onEvent: (e: LiveEvent) => void, enabled = true) {
  const cb = useRef(onEvent);
  cb.current = onEvent;
  useEffect(() => {
    if (!enabled) return;
    let ws: WebSocket | null = null;
    let stopped = false;
    let retry = 1000;
    let ping: ReturnType<typeof setInterval> | undefined;
    const connect = () => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token || stopped) return;
      ws = new WebSocket(wsUrl(token));
      ws.onopen = () => {
        retry = 1000;
        ping = setInterval(() => ws?.readyState === WebSocket.OPEN && ws.send('ping'), 25000);
      };
      ws.onmessage = (m) => {
        try { cb.current(JSON.parse(m.data)); } catch { /* ignore malformed */ }
      };
      ws.onclose = () => {
        clearInterval(ping);
        if (!stopped) setTimeout(connect, retry = Math.min(retry * 2, 15000));
      };
    };
    connect();
    return () => {
      stopped = true;
      clearInterval(ping);
      ws?.close();
    };
  }, [enabled]);
}
